var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.accordionData),function(accordionItem,index){return _c('div',{key:_vm.uniquePrefix + index,staticClass:"accordion",on:{"click":function($event){return _vm.itemClicked(_vm.uniquePrefix + index)}}},[(
        (_vm.currentPackage === ' $500 Membership' &&
          accordionItem.title !== 'Personal Rays Representative') ||
        _vm.currentPackage !== ' $500 Membership'
      )?_c('AccordionItem',{attrs:{"item":accordionItem,"itemId":_vm.uniquePrefix + index,"active":_vm.activeItemKey === _vm.uniquePrefix + index}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }